<template
  ><!-- 超级裂变神券 -->
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <img
        class="pointer"
        @click="returnBack()"
        src="@/assets/thdImg/pages/back.svg"
        alt=""
      />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>

    <div :class="{ formBox: localStep != 0 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 0">
        <!--  -->
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid rgba(123,97,255,0.15);"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05);"
                ></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    style="width:100%;max-height: 380px;"
                    :src="item.templateUrl"
                    alt=""
                  />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.title }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 0">
        <div class="card-point tipBg">
          <div class="card-rule">商家须知：</div>
          <div class="card-connet">
            <p>
              1、为避免因奖品发完活动提前结束引起客诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算
            </p>
            <p>
              2、为避免修改成团条件导致客诉，活动创建后成团条件将不可修改，请在创建时仔细核对
            </p>
            <p>3、活动期间每个用户，同一优惠最多获得一次</p>
          </div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="120px"
        >
          <div class="newsInfo">基本信息</div>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请填入活动名称"
              style="width: 400px"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <!-- <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                :disabled="!isSave && activityData.id == 20"
                style="width: 400px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []" ></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" /> -->
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime()"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #7B61FF">{{ timeDay }}</span> 天 <span style="color: #7B61FF">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>

          <div class="newsInfo">优惠券设置</div>
          <el-form-item label="主券设置:" required></el-form-item>
          <el-form-item>
            <el-table
              :data="awardSettingsLsit"
              style="width: 100%; border: 1px solid #f0f0f0;margin-top: 15px;"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="优惠券名称">
                <template slot-scope="scope">
                  <span v-if="activityData.isStart">{{ scope.row.title }}</span>
                  <span class="s" @click="handleChoise()" v-else-if="scope.row.title">{{ scope.row.title }}</span>
                  <span class="s" @click="handleChoise()" v-else>选择优惠券</span>
                </template>
              </el-table-column>

              <el-table-column label="优惠券信息">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.prizeType | prizeType }}</span> -->
                  <span>
                    {{ scope.row.quota ? "满" + scope.row.quota + "元" : ""
                    }}{{ scope.row.price ? "减" + scope.row.price : "" }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="领券时间" prop="beginTime" width="320">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.beginTime }} - {{ scope.row.endTime }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="发放人数"
                prop="totalAmount"
              ></el-table-column>
               <el-table-column
                label="单次发放数量"
                prop="numPerSending"
              ></el-table-column>
              <el-table-column label="助力人数">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.inviteNum"
                    @input="scope.row.inviteNum = getNumberData(1, $event, 0, 1, 5)"
                    maxlength="10"
                    class="inputcount"
                    show-word-limit
                    style="width: 150px"
                    placeholder="请输入"
                    :disabled="isStart"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="isStart">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.title"
                    @click="itemAddNum('awardSettingsLsit',scope.$index)">增加奖品数量</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item label="子券设置:" required></el-form-item>
          <el-form-item label="被分享者身份:" required>
            <div style="display: flex;">
              <el-checkbox
                style="margin-right: 15px;"
                v-model="checkAll"
                @change="handleCheckAllChange"
                :disabled="isStart"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="checkedInvitee"
                @change="handleCheckedCitiesChange"
                :disabled="isStart"
              >
                <el-checkbox
                  style="margin-right: 15px;"
                  v-for="item in Invitee"
                  :label="item.value"
                  :key="item.value"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
              <el-tooltip
                class="item"
                effect="light"
                placement="bottom"
                width="300px"
              >
                <template #content>
                  <div>
                    1、平台新用户：历史从来在京东平台完整下过单的用户；<br />
                    2、品类新用户：针对品类维度，历史来，从未在所选品类范围内完整下过单的用户为品类新用户；<br />
                    3、店铺新用户：针对店铺维度，历史来，从未在所选店铺范围内完整下过单的用户为店铺新用户；<br />
                    4、店铺近180天未下单客户：针对店铺维度，历史有过订单，且近180天未在所选店铺范围内完整下过单的用户；<br />
                    5、店铺已购客户：历史有在店铺完整下过单的用户；<br />
                    6、未入会用户：未开卡入会的用户；<br />
                    7、开卡会员：已开卡入会的用户；<br />
                  </div>
                </template>
                <el-button type="text" style="width: 35px;color:#ccc">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </div>
            <div style="color: red;">
              注意：如不符合勾选的用户身份，则表示不能为好友助力
            </div>
          </el-form-item>
          <el-form-item label="优惠券设置:" required>
            <el-button style="width: auto;" @click="handleClick()" :disabled="isStart">{{
              superSplitCoupon ? "按用户身份设置" : "统一设置"
            }}</el-button>
            <el-table
              :data="FissionVoucherList"
              style="width: 100%; border: 1px solid #f0f0f0;margin-top: 15px;"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column
                label="发放对象"
                width="180"
                v-if="!superSplitCoupon"
              >
                <template slot-scope="scope">
                  <span>{{ typeChinese(scope.row.memberType) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="优惠券名称">
                <template slot-scope="scope">
                  <span
                    v-if="activityData.isStart"
                    >{{ scope.row.title }}</span
                  >
                  <span
                    class="s"
                    @click="selectPacket(scope.$index, scope.row)"
                    v-else-if="scope.row.title"
                    >{{ scope.row.title }}</span
                  >
                  <span
                    class="s"
                    @click="selectPacket(scope.$index, scope.row)"
                    v-else
                    >选择优惠券</span
                  >
                </template>
              </el-table-column>

              <el-table-column label="优惠券信息">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.prizeType | prizeType }}</span> -->
                  <span>
                    {{ scope.row.quota ? "满" + scope.row.quota + "元" : ""
                    }}{{ scope.row.price ? "减" + scope.row.price : "" }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="领券时间" width="320">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.beginTime }} - {{ scope.row.endTime }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="发放人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.totalAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单次发放数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.numPerSending }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="优先级"
                v-if="!superSplitCoupon"
                width="150"
              >
                <template slot="header">
                  <span>优先级</span>
                  <el-popover
                    placement="top-start"
                    width="480"
                    offset="100"
                    trigger="hover"
                    content="优先级：可进行上下移动调整优先级，越前面的优先级越高，表示当用户存在多种身份时，当库存不足不为0的情况C端默认展示优先级最高对应的优惠券，当优先级高的优惠券库存为0则根据优先级依次判断展示；"
                  >
                    <span slot="reference">
                      <i class="el-icon-question" style="color:#ccc"></i>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <div class="taskbox-content" v-if="!isStart">
                    <span
                      class="pointer"
                      style="color:#7F85E9;margin-right: 10px;"
                      @click="changeSort(scope.$index, 0)"
                      v-if="scope.$index != 0"
                      >上移</span
                    >
                    <span
                      class="pointer"
                      style="color:#7F85E9"
                      @click="changeSort(scope.$index, 1)"
                      v-if="scope.$index != FissionVoucherList.length - 1"
                      >下移</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="isStart">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.title"
                    @click="itemAddNum('FissionVoucherList',scope.$index)">增加奖品数量</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <orderShopInfo v-model="customerPaperwork" :isShowShopName="false"/>
          <div class="newsInfo">曝光商品</div>
          <el-form-item label="曝光商品:">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
              :disabled="!isSave"
            >
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px;display: inline-block;"
              :class="[{ add_btn1: ruleForm.exposureSwitch },'zindexBox']"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false ||(!isSave && activityData.id == 20)"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false ||(!isSave && activityData.id == 20)"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block"/>&nbsp;
                  <div v-if="(!isSave && activityData.id == 20 )">
                    <!-- <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      class="delectIcom"
                    /> -->
                  </div>
                  <div class="delectPosible" v-else>
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <div class="newsInfo">分享设置</div>
          <el-form-item label="小程序分享标题:" required label-width="125">
            <el-input
                type="text"
                style="width: 400px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                :disabled="isStart"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required label-width="125">
            <el-input
                type="text"
                style="width: 400px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                :disabled="isStart"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required label-width="130">
            <div class="miniAppPic" style="margin-left:16px;">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="isStart"
                  >
                  <el-button size="mideal" class="returnBtn">自定义上传</el-button>
                </el-upload>
                <span class="reset" @click="picUrlReset1">重置</span>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="newsInfo">活动规则</div>
          <el-form-item label="规则内容:" required>
            <div
              style="
              width: 570px;
              backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length - 1
                    : 0
                }}/2000）
              </div>
              <div>
                <el-button
                  type="primary"
                  class="generate"
                  plain
                  @click="generateRule"
                >
                  生成规则
                </el-button>

                <span class="desc">
                  <i class="el-alert__icon el-icon-info"></i>
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </span>
              </div>
            </div>
          </el-form-item>
          <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
          <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <el-button
        v-show="!itemId"
        class="returnBtn"
        size="medium"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button
      >
      <el-button class="returnBtn createBtn" @click="saveDraft" v-if="hasDraftBtn">存为草稿</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存并完成设置</el-button
        >
        <el-button
          v-show="!itemId"
          v-if="statusComment"
          class="keepBtn"
          type="primary"
          size="medium"
          @click="saveEdit"
          v-preventReClick
          >保存并完成设置</el-button
        >
      </template>
      <el-button
        v-show="itemId"
        class="returnBtn"
        size="medium"
        @click="cancelEdit"
        >取消</el-button
      >
      <el-button v-show="itemId" class="keepBtn" type="primary" size="medium"
        >保存并完成设置</el-button
      >
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      :isSupportVirtualGroup="true"
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择优惠券自营 -->
    <selectPrize
      v-model="dialogPrize"
      @closePrize="closePrize"
      :outShopShow="true"
      :inShopShow="false"
    ></selectPrize>
    <!-- 添加优惠券 pop -->
    <add-coupon
      :isSuperFission="true"
      :fromInfo="echoDate"
      :isShow="addCouponIsShow"
      :isStart="isStart"
      @close="addCouponIsShow = false"
      @funcMes="addStatus"
    ></add-coupon>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
  </div>
</template>

<script>
import addCoupon from "./add_coupon1";

import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
// import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import { updateCommon } from "@/api/integralCenter/integralTask";
import draggable from "vuedraggable";
import {
  getComment,
  editCommentCreate,
  commentCreate,
  splitCouponCreate,
  getSplitCoupon,
  editSplitCoupon,
  getInviteeTypes,
  SplitSuperEdit,
  SplitSuperSave,
  editSplitSuper,
} from "@/api/paradiseAndTaskCommonController.js";
import addPrizeNum from "./components/add-prize-num.vue";
const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "京东E卡",
  "爱奇艺会员",
  "京东PLUS会员",
  "现金红包",
];
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    addCoupon,
    addPrizeNum
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    statusComment: {
      type: Boolean,
      default: false,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapState(["venderType"]),
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    }
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });

      this.winningRate = this.winningRate.toFixed(3);
    },
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      }
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "9") {    
        result = "谢谢参与";
      } else if (num == "14") {
        result = "实物（随单发）";
      }
      return result;
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ]; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp
          .toString()
          .split("")
          .reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
              ? ""
              : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        if (num >= 10 && num < 20) {
          newNum = newNum.substring(1, 3);
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },
  data() {
    return {
      customerPaperwork: {},
      isKeyActivity: 0,
      placementPosition: [],
      isShowTip: false,
      addCouponIsShow: false,
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()-24*60*60*1000;
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      appraiseValue: "1",
      options: [
        {
          value: "1",
          label: "近7天完成的评价",
        },
        {
          value: "2",
          label: "近15天完成的评价",
        },
        {
          value: "3",
          label: "近1个月完成的评价",
        },
        {
          value: "4",
          label: "近2个月完成的评价",
        },
        {
          value: "0",
          label: "自定义",
        },
      ],
      scores: ["5"],
      labelVal: [
        {
          name: "一星",
          value: "1",
        },
        {
          name: "二星",
          value: "2",
        },
        {
          name: "三星",
          value: "3",
        },
        {
          name: "四星",
          value: "4",
        },
        {
          name: "五星",
          value: "5",
        },
      ],
      winningRate: 0,
      theNum: 0,
      index: 0,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
      ],
      // 裂变
      dialogPrize: false,
      indexCoupon: 0,
      FissionVoucherList: [
      ],
      // hongbaoyu
      awardSettingsLsit: [
        {
          prizeType: 1,
          price: null,
          title: "",
          singleAmount: null,
          totalAmount: "",
          inviteNum: null,
          takeEndTime: null,
          takeBeginTime: null,
          isMain: 1,
          quota: null,
          numPerSending: null,
        },
      ],
      awardIndex: 0,
      draggingIdFilter: [],
      mainImagelistFilter: [],
      isDraggingFilter: false,
      selectGoodsStateFilter: false,
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftList: [], // 礼包模板
      levelList: [],
      disableTime: false,
      qrcode: null,
      order: "",
      showDialog: false,
      isShow: false,
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            // return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime() || time.getTime() < Date.now() - 8.64e7;
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        // selectableRange: (() => {
        //   let data = new Date();
        //   let hour = data.getHours();
        //   let minute = data.getMinutes();
        //   let second = data.getSeconds();
        //   return [`${hour}:${minute}:${second} - 23:59:59`];
        // })(),
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      ruleForm: {
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        activityRulesText: "", //生成规则
        // 评价有礼
        condFollow: false, // 是否需要关注店铺
        totalMaxRewardNumber: "", //活动期间最大中奖次数
        oneDayMaxRewardNumber: "", //每人每天最大中奖次数
        startCommentTime: "", //评价开始时间
        endCommentTime: "", //评价结束时间
        commentFilter: "", // 评价内容限制，多个用英文逗号隔开
        wordNum: "", //评价字数限制
        imgNum: "", //评价图片张数限制
        videoNum: "", //评价视频限制
        isCommentFilter: false, //是否勾选过滤条件
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        //红包雨
        gameTime: "30",
        everyoneWinningNum: "",
        winningNum: "",
        itemList: [], //曝光商品集合
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
      },
      sharePic: "", // 默认分享图
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
      },
      orderCRM: false,
      orderCRMtime: "",
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}`,
      orderShow: false,
      checkAll: false,
      checkedInvitee: [],
      Invitee: [],
      checkAll: true,
      superSplitCoupon: false,
      isMain: 1,
      isStart: false, // 进行中活动状态
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  created() {
    this.isStart = this.activityData.isStart ? true : false
    console.log('当前玩法id',this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
    // 数据初始化
    this.getPolite();
    // 修改 数据回显
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      this.getSplitCouponEdit();
    }
    // 新增活动默认时间
    if(!this.valueRow){
      this.ruleForm.activityStartTime = this.$getDate(30)[0]
      this.ruleForm.activityEndTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getCodeIMG();
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount
      };
      if( !this.toAddItem.title ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.messaga);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      if(this.isStart) return;
      this.ruleForm.sharePic = this.sharePic
    },
    // 数据初始化
    async getPolite() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "31",
          openMerchant: "",
          openType: 0,
          templateUrl: require("@/assets/thdImg/cover/cjlb.png"),
          updateTime: "2021-11-12 10:19:55",
          title: "超级裂变神券",
        },
      ];
      // 用户身份
      const { data } = await getInviteeTypes();
      this.Invitee = data.filter((i) => i.value != 0);
      if (!this.activeValue) this.handleCheckAllChange(true);
    },

    // 修改 裂变 数据回显
    getSplitCouponEdit() {
      editSplitSuper(this.valueRow.id).then((res) => {
        if(res.data.ruleDto){
          this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
          this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
          this.ruleForm.sharePic = res.data.ruleDto.sharePic;
          this.customerPaperwork = res.data.ruleDto.customerPaperwork ? JSON.parse(res.data.ruleDto.customerPaperwork) : {};
        }else{
          this.ruleForm.shareTitle = "";
          this.ruleForm.shareIntroduce = "";;
          this.ruleForm.sharePic = "";;
        }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.isKeyActivity = res.data.isKeyActivity || 0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(',') : ["SHOP"];

        if (res.data.inviteeType == "0") {
          this.checkedInvitee = this.Invitee.map((item) => item.value);
          this.checkAll = true;
        } else {
          this.checkAll = false;
          this.checkedInvitee = res.data.inviteeType.split(",");
          setTimeout(() => {
            this.checkedInvitee = this.checkedInvitee.map((item) => {
              return (item = Number(item));
            });
          });
        }
        if(!this.activityData.isCopy){
          this.ruleForm.activityRulesText = String(res.data.ruleDescription);// 规则
          
          this.superSplitCoupon = res.data.inviteeSetting == 0;
          this.awardSettingsLsit = [
            {
              ...res.data.pointActivityPrizeDTO,
              beginTime: res.data.pointActivityPrizeDTO.takeBeginTime,
              endTime: res.data.pointActivityPrizeDTO.takeEndTime,
              inviteNum: res.data.inviteNum,
              numPerSending: res.data.pointActivityPrizeDTO.innerCouponDto ? res.data.pointActivityPrizeDTO.innerCouponDto.numPerSending : null,
            },
          ];
          // 草稿箱兼容
          if(this.awardSettingsLsit[0].innerCouponDto){
            this.awardSettingsLsit[0].innerCouponDto.minNum = this.awardSettingsLsit[0].innerCouponDto.num
          }
          if(res.data.pointActivityPrizeDTOList && res.data.pointActivityPrizeDTOList.length){
            this.FissionVoucherList = res.data.pointActivityPrizeDTOList.map(
              (item) => {
                return {
                  ...item,
                  beginTime: item.takeBeginTime,
                  endTime: item.takeEndTime,
                  numPerSending: item.innerCouponDto ? item.innerCouponDto.numPerSending : null,
                };
              }
            );
            this.FissionVoucherList.forEach(item=>{
              item.innerCouponDto.minNum = item.innerCouponDto.num
            })
          }
          this.FissionVoucherList.forEach(item=>{
            item.innerCouponDto.minNum = item.innerCouponDto.num
          })
          // this.FissionVoucherList[0].innerCouponDto.minNum = this.FissionVoucherList[0].innerCouponDto.num
          // 奖品
          this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
        }else{
          this.handleCheckAllChange(true);
        }
        // 奖品
        //曝光商品
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        this.selectGoodsArr = res.data.itemList;
        this.mainImagelist = res.data.itemList;
        this.itemListFor = res.data.itemList;
        this.activityTimeChange();
      });
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.Invitee.length;
      if (!this.superSplitCoupon) {
        this.FissionVoucherList = value.map((item) => {
          let obj = {};
          let obj1 = {
            memberType: item,
            prizeType: null,
            price: null,
            title: "",
            singleAmount: null,
            totalAmount: "",
            inviteNum: null,
            takeEndTime: null,
            takeBeginTime: null,
            isMain: 0,
            quota: null,
          };
          let isfaly = false;
          this.FissionVoucherList.forEach((val1) => {
            if (val1.memberType == item) {
              obj = val1;
              isfaly = true;
            }
          });
          return isfaly ? obj : obj1;
        });
      }
    },
    handleCheckAllChange(value) {
      this.checkedInvitee = value ? this.Invitee.map((item) => item.value) : [];
      if (!this.superSplitCoupon) {
        this.FissionVoucherList = value
          ? this.Invitee.map((item) => {
              let obj = {};
              let obj1 = {
                memberType: item.value,
                prizeType: 1,
                price: null,
                title: "",
                singleAmount: null,
                totalAmount: "",
                inviteNum: null,
                takeEndTime: null,
                takeBeginTime: null,
                isMain: 0,
                quota: null,
              };
              let isfaly = false;
              this.FissionVoucherList.forEach((val1) => {
                if (val1.memberType == item.value) {
                  obj = val1;
                  isfaly = true;
                }
              });
              return isfaly ? obj : obj1;
            })
          : [];
      }
    },
    typeChinese(val) {
      let str = "";
      this.Invitee.forEach((item) => {
        if (item.value == val) str = item.name;
      });
      return str;
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log(data, prizeType, 2233);
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        this.prizeSettingList[this.index].singleAmount = 1;
        this.prizeSettingList[this.index].quota = data.quota;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price =
        data.discount || data.singleAmount;

      this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      console.log(this.prizeSettingList, 123);
    },
    handleClick() {
      this.superSplitCoupon = !this.superSplitCoupon;
      if (this.superSplitCoupon) {
        this.FissionVoucherList = [
          {
            prizeType: 1,
            price: null,
            title: "",
            singleAmount: null,
            totalAmount: "",
            inviteNum: null,
            takeEndTime: null,
            takeBeginTime: null,
            isMain: 0,
            quota: null,
          },
        ];
      } else {
        this.FissionVoucherList = this.checkedInvitee.map((item) => {
          return {
            memberType: item,
            prizeType: 1,
            price: null,
            title: "",
            singleAmount: null,
            totalAmount: "",
            inviteNum: null,
            takeEndTime: null,
            takeBeginTime: null,
            isMain: 0,
            quota: null,
          };
        });
      }
    },
    handleChoise() {
      this.isMain = 1;
      this.echoDate = this.awardSettingsLsit[0].innerCouponDto
        ? this.awardSettingsLsit[0].innerCouponDto
        : {};
      if (this.venderType) {
        this.dialogPrize = true;
      } else {
        this.addCouponIsShow = true;
      }
    },
    // 上移下移
    changeSort(index, type) {
      // index 为下标 上移 type 为 0， 下移为 1.  i==1为taskList1 2为taskList2
      this.FissionVoucherList.splice(
        type ? index : index - 1,
        1,
        ...this.FissionVoucherList.splice(
          type ? index + 1 : index,
          1,
          this.FissionVoucherList[type ? index : index - 1]
        )
      );
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/cjlb.png`;
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url,
        });
      }
    },
    //pop店铺获取优惠券信息
    addStatus(val) {
      // this.awardSettingsLsit[0].assetsId = data
      console.log("data", val);
      if (this.isMain == 1) {
        this.awardSettingsLsit[0].innerCouponDto = val;
        this.awardSettingsLsit[0].quota = val.quota;
        this.awardSettingsLsit[0].beginTime = val.takeBeginTime;
        this.awardSettingsLsit[0].endTime = val.takeEndTime;
        this.awardSettingsLsit[0].totalAmount = val.provideNum;
        this.awardSettingsLsit[0].title = val.name;
        this.awardSettingsLsit[0].price = val.discount;
        this.awardSettingsLsit[0].couponType = 1;
        this.awardSettingsLsit[0].singleAmount = 1;
        this.awardSettingsLsit[0].numPerSending =  val.numPerSending;
      } else {
        this.FissionVoucherList[this.indexCoupon].quota = val.quota;
        this.FissionVoucherList[this.indexCoupon].beginTime = val.takeBeginTime;
        this.FissionVoucherList[this.indexCoupon].endTime = val.takeEndTime;
        this.FissionVoucherList[this.indexCoupon].totalAmount = val.provideNum;
        this.FissionVoucherList[this.indexCoupon].title = val.name;
        this.FissionVoucherList[this.indexCoupon].price = val.discount;
        this.FissionVoucherList[this.indexCoupon].couponType = 1;
        this.FissionVoucherList[this.indexCoupon].innerCouponDto = val;
        this.FissionVoucherList[this.indexCoupon].singleAmount = 1;
        this.FissionVoucherList[this.indexCoupon].numPerSending = val.numPerSending;

        console.log(this.FissionVoucherList, 111111);
        // }
      }
    },
    // 裂变  奖品确定
    closePrize(val, params) {
      console.log(params);
      if (val) {
        // if (this.venderType && val.couponType == 1) {
        //   return this.$message.warning("此类型奖品暂时不支持自营店铺！");
        // }
        // let isflay = false;
        // this.FissionVoucherList.forEach((item) => {
        //   if (item.assetsId === params.couponId) {
        //     isflay = true;
        //   }
        // });
        // if (isflay) {
        //   return this.$message.warning("你已选用该优惠券，请重新选择");
        // }
        if (this.isMain == 1) {
          this.awardSettingsLsit[0].quota = params.quota;
          this.awardSettingsLsit[0].prizeType = 1;
          this.awardSettingsLsit[0].assetsId = params.couponId;
          this.awardSettingsLsit[0].couponType = params.couponType;
          this.awardSettingsLsit[0].price =
            params.discount || params.singleAmount;
          this.awardSettingsLsit[0].title =
            params.name.length >= 12
              ? params.name.substring(0, 12)
              : params.name;
          this.awardSettingsLsit[0].beginTime = params.beginTime;
          this.awardSettingsLsit[0].endTime = params.endTime;
          this.awardSettingsLsit[0].singleAmount = 1;
        } else {
          this.FissionVoucherList[this.indexCoupon].quota = params.quota;
          this.FissionVoucherList[this.indexCoupon].prizeType = 1;
          this.FissionVoucherList[this.indexCoupon].assetsId = params.couponId;
          this.FissionVoucherList[this.indexCoupon].couponType =
            params.couponType;
          this.FissionVoucherList[this.indexCoupon].price =
            params.discount || params.singleAmount;
          this.FissionVoucherList[this.indexCoupon].title =
            params.name.length >= 12
              ? params.name.substring(0, 12)
              : params.name;
          this.FissionVoucherList[this.indexCoupon].beginTime =
            params.beginTime;
          this.FissionVoucherList[this.indexCoupon].endTime = params.endTime;
          this.FissionVoucherList[this.indexCoupon].singleAmount = 1;
        }
      }
      this.dialogPrize = false;
    },
    // 裂变  选择奖品
    selectCoupon(index) {
      this.dialogPrize = true;
      this.indexCoupon = index;
    },
    // 裂变  添加优惠券
    addCoupon() {
      this.FissionVoucherList.push({
        title: "",
        prizeType: null,
        price: null,
        totalAmount: null,
        quota: "",
        assetsId: "",
        groupNums: "",
        couponType: "",
      });
    },
    // 红包雨  弹框
    getTheDataAward(data, prizeType) {
      console.log(data, prizeType, 2233);
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }

      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal =
          data.quantityTotal;
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(
          data.giftType
        );
      }
      this.awardSettingsLsit[this.awardIndex].price =
        data.discount || data.singleAmount;

      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title =
          data.discount + "店铺积分";
      } else {
        this.awardSettingsLsit[this.awardIndex].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount =
          data.singleAmount;
      }
    },
    // 红包雨
    selectPacket(index, item) {
      this.isMain = 2;
      // this.$refs.selectProductAward.openDialog();
      // this.JingdouCount.prizeCount = item.totalAmount;
      this.indexCoupon = index;
      this.echoDate = item.innerCouponDto ? item.innerCouponDto : {};
      if (this.venderType) {
        this.dialogPrize = true;
      } else {
        this.addCouponIsShow = true;
      }
    },
    // 添加优惠券
    addPacket() {
      this.awardSettingsLsit.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        awardMinScore: null,
        awardMaxScore: null,
        awardLevel: null,
      });
    },
    // 清空  删除
    deletePacket(item, num = "2") {
      // 1为清空
      if (num === "1") {
        item.prizeType = null;
        item.price = null;
        item.title = "";
        item.totalAmount = "";
        item.awardMinScore = null;
        item.awardMaxScore = null;
        item.awardLevel = "";
      } else {
        this.awardSettingsLsit.splice(item, 1);
      }
    },
    //模板下一步
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    // 参与商品图片拖拽
    onEndFilter() {
      this.isDraggingFilter = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelistFilter.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingIdFilter = arr;
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let commentStart = new Date(this.ruleForm.startCommentTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiredIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart =
      //   this.ruleForm.activityStartTime &&
      //   this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd =
      //   this.ruleForm.activityEndTime &&
      //   this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.activityEndTime)-new Date(this.ruleForm.activityStartTime)) / 1000 / 60 / 60 / 24);

        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.ruleForm.activityEndTime = "";
        return;
      }
      const day = 86400000 * 60;
      if (start - commentStart > day && commentStart && start) {
        this.ruleForm.startCommentTime = "";
        this.$message.warning("评价开始时间最小范围在活动时间的前60天");
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      // 裂变
      let SplitCouponActivityDTO = {
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        inviteeSetting: this.superSplitCoupon ? 0 : 1,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        itemList: this.itemListFor, //曝光商品集合
        inviteNum: this.awardSettingsLsit[0].inviteNum,
        pointActivityPrizeDTOList: [
          ...this.awardSettingsLsit,
          ...this.FissionVoucherList,
        ],
        inviteeType:
          this.checkedInvitee.length == this.Invitee.length
            ? "0"
            : this.checkedInvitee.join(","),
        isKeyActivity: this.isKeyActivity, //是否重点活动
        placementPosition: this.placementPosition.join(','), //活动投放位置
      };
      SplitCouponActivityDTO.ruleDTO = {
        shareTitle: this.ruleForm.shareTitle,
        shareIntroduce: this.ruleForm.shareIntroduce,
        sharePic: this.ruleForm.sharePic,
        customerPaperwork: JSON.stringify(this.customerPaperwork),
      }
      let list1 = this.awardSettingsLsit.map((item) => {
        return {
          ...item,
          prizeType: 1,
          singleAmount: 1,
          isMain: 1,
          takeBeginTime: item.beginTime,
          takeEndTime: item.endTime,
        };
      });
      let isfaly = false;
      let MaxIndex = 10;
      let list2 = this.FissionVoucherList.map((item, index) => {
        if (!item.title) {
          isfaly = true;
        }
        MaxIndex = MaxIndex - 1;
        return {
          ...item,
          sort: MaxIndex,
          prizeType: 1,
          singleAmount: 1,
          isMain: 0,
          takeBeginTime: item.beginTime,
          takeEndTime: item.endTime,
        };
      });
      // 排序
      // list.sort((a, b) => {
      //   return b.sort - a.sort;
      // });
      SplitCouponActivityDTO.pointActivityPrizeDTOList = [...list1, ...list2];
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        SplitCouponActivityDTO.itemList = b;
      }
      if(!this.isDraft){
        //活动名称的限制
        if (
          !this.ruleForm.activityName ||
          this.ruleForm.activityName.length == 0
        ) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return
        }
        if (!this.awardSettingsLsit[0].inviteNum) {
          return this.$message.warning("请输入助力人数");
        }
        if (!this.awardSettingsLsit[0].title) {
          return this.$message.warning("请设置主券");
        }
        if (isfaly) {
          return this.$message.warning("请设置子券");
        }
        if (this.checkedInvitee.length == 0) {
          return this.$message.warning("请选择被分享者身份");
        }
        // if (SplitCouponActivityDTO.pointActivityPrizeDTOList.length > 0) {
        //   let taskIsflay = false;
        //   let activityStartTime = new Date(this.ruleForm.activityStartTime).valueOf();
        //   let activityEndTime = new Date(this.ruleForm.activityEndTime).valueOf();
        //   SplitCouponActivityDTO.pointActivityPrizeDTOList.forEach((item) => {
        //     if (item.takeBeginTime) {
        //       let startTime = new Date(item.takeBeginTime).valueOf();
        //       let endTime = new Date(item.takeEndTime).valueOf();
        //       if (startTime > activityStartTime || endTime < activityEndTime) {
        //         taskIsflay = true;
        //       }
        //     }
        //   });
        //   if (taskIsflay) return this.$message.warning(`活动时间必须在优惠券领取时间范围内，请重新调整活动时间`);
        // }
        if(!this.useValidateMoreActSet(this)) {
          return;
        }
        //请添加曝光商品！
        if (this.ruleForm.exposureSwitch) {
          if (this.itemListFor.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          }
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        //活动规则不能为空
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
        if(this.placementPosition.length==0) {
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
          let res;
          if(this.activityData.isStart){
            let params = {
              activityId: this.valueRow.id,
              // endTime: SplitCouponActivityDTO.endTime,
              ruleDescription: SplitCouponActivityDTO.ruleDescription,
              // prizes: SplitCouponActivityDTO.pointActivityPrizeDTOList.filter(item=>item.totalAmount).map(item=>{
              //   return {
              //     prizeId: item.id,
              //     totalAmount: item.totalAmount,
              //   }
              // })
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              endTime: this.ruleForm.activityEndTime,
            }
            res = await updateCommon(params)
          }else{
            res = await SplitSuperEdit({...SplitCouponActivityDTO,id: this.valueRow.id})
          }
          // SplitSuperEdit({
          //   ...SplitCouponActivityDTO,
          //   id: this.valueRow.id,
          // }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            } else {
              if(res.message){
                this.$message.error(res.message);
              }else{
                this.$message.error(res.data.message);
              }
            }
          // });
        } else {
          const query = { ...SplitCouponActivityDTO }
          if(this.isDraft){
            query.status = 5
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            query.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
              delete query.id
          }
          SplitSuperSave(query).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.message);
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }

        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "1、活动时间：",
        text3 = "2、被分享者身份：",
        text0 = "3、领券需助力人数：",
        text4 =
          "4、活动期间，同一优惠，用户只能为一位好友助力，也只能发起一次活动；同一优惠同一用户最多只能享受一次：",
        text5 = "5、优惠券数量有限，先到先得；",
        text6 = "注：优惠券发放形式：",
        text8 =
          "  （1）分享者发起活动即表示同意领取优惠券，助力满人后优惠券会自动发放到用户账户；被分享者助力成功后优惠券也会自动发放到用户账户；",
        text7 = "【活动参与主体资格】",
        text9 =
          "  （1）每位自然人用户仅能使用一个京东账号参与活动，微信号、Q、京东帐号、手机号码等任一信息一致或指向同一用户的，视为同一个用户，则第一个参与本活动的账号参与结果有效,其余账号参与结果均视为无效；",
        text10 =
          "  （2）若发现同一位用户使用不同账号重复参与活动，承办方有权取消其参与资格；",
        text11 = "【注意事项】",
        text12 =
          "  （1）活动过程中，凡以不正当手段〈如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等〉参与本次活动的用户，商家有权终止其参与活动，并取消其参与资格（如优惠已发放，商家有权追回)，如给商家造成损失的,商家将保留向违规用户继续追索的权利；",
        text13 =
          "  （2）如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错,活动不能正常进行的)，商家有权取消、修改或暂停本活动；",
        text14 = "  (3）是否获得优惠以活动发布者后台统计结果为准。";
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text1 =
          "1、活动时间：" +
          this.ruleForm.activityStartTime +
          "~" +
          this.ruleForm.activityEndTime +
          ";";
      }
      if (this.checkedInvitee.length) {
        let str = "";
        this.checkedInvitee.forEach((item) => {
          str = str + this.typeChinese(item) + ",";
        });
        text3 = "2、被分享者身份：" + str;
      }
      if (this.awardSettingsLsit[0].inviteNum) {
        text0 =
          "3、领券需助力人数：" + this.awardSettingsLsit[0].inviteNum + "人;";
      }
      let Arr1 = [];
      Arr1 = [
        text1,
        text3,
        text0,
        text4,
        text5,
        text6,
        text8,
        text7,
        text9,
        text10,
        text11,
        text12,
        text13,
        text14,
      ];

      let newText = "";
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + item + "\n";
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.mainImagelistFilter = [];
      }
      // console.log(this.selectGoodsFilterArr, this.itemListForFilter);
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      console.log(data, 11111);
      if (data) {
        this.itemListForFilter = [];
        this.mainImagelistFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          this.mainImagelistFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "1") {
          if (e.target.value > 9) {
            e.target.value = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e.target.value > 1) {
            e.target.value = "";
          }
        }
        if (num == "5") {
          if (e.target.value < 1 || e.target.value > 5) {
            e.target.value = "";
          }
        }
      } else {
        if (
          num.quantityTotal &&
          num.price &&
          num.totalAmount &&
          num.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...num,
            prizeCount: num.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if(this.activityData.isCopy) return this.localStep = 0;
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.activityName = "";
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.ruleForm.condFollow = false; // 是否需要关注店铺
      this.awardIndex = 0;
      this.draggingIdFilter = [];
      this.mainImagelistFilter = [];
      this.isDraggingFilter = false;
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      this.ruleForm.skuIdList = []; //skuId集合，多个，隔开
      this.mainImagelist = []; //图片拖拽排序
      this.isDragging = false;
      this.itemListFor = []; //商品弹框选择商品数据
      this.selectGoodsState = false; //曝光商品弹窗
      this.ruleForm.activityRulesText = "";
      this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
    // 组队人数是发放的N倍
    multiple(num, num1, index) {
      if (!num) {
        this.$message.warning("请先填写组队人数！");
        this.FissionVoucherList[index].totalAmount = "";
      } else {
        if (Number(num1) % Number(num) != 0) {
          this.$message.warning(
            "发放人数必须为组队人数的N倍，以确保奖品发放顺利；"
          );
          this.FissionVoucherList[index].totalAmount = "";
        }
      }
    },
    // 区间递减
    scoreChange(item, index) {
      if (index != 0) {
        const num = Number(this.awardSettingsLsit[index - 1].awardMinScore);
        if (Number(item.awardMaxScore) >= num) {
          this.awardSettingsLsit[index].awardMaxScore = "";
          this.$message.warning("奖项设置分数必须是递减的，且区间不能重复；");
          return;
        }
      }
      if (
        (Number(item.awardMaxScore) <= Number(item.awardMinScore) &&
          item.awardMinScore &&
          item.awardMaxScore) ||
        item.awardMaxScore == 0
      ) {
        this.awardSettingsLsit[index].awardMaxScore = "";
        this.$message.warning("奖项设置最大分数必须大于最小分数");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inputcount {
  /deep/.el-input__count {
    display: none !important;
  }
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}

.termAdd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #333;
  p {
    margin: 0;
  }
  .add {
    margin-left: 4px;
    color: #7b61ff;
  }
}
.s {
  color: #7b61ff;
  cursor: pointer;
}
.tips {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 13px 30px;
  background: #fffaee;
  font-size: 13px;
  color: #333;
  img {
    display: inline-block;
    float: left;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 9px 4px 0 3px;
  }
  i {
    color: #fe8f8a;
    opacity: 0.7;
  }
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}
.set {
  display: inline-block;
  margin-top: 30px;
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #7b61ff;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.rule_box {
  width: 860px;
  // height: 217px;
  margin-top: 9px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;

  &_middle {
    padding-top: 10px;
  }
  &_content {
    padding: 0 15px;
    img {
      display: inline-block;
      float: left;
      position: absolute;
      width: 14px;
      height: 14px;
      color: #ffffff;
      margin: 9px 4px 0 3px;
    }
    p {
      padding-left: 21px;
    }
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #7b61ff;
    color: #7b61ff;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #7b61ff;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7b61ff;
  }
  color: #999;
}
.flex {
  display: flex;
  align-items: center;
}

.add_btn1 {
  cursor: pointer;
  color: #7b61ff;
  border: 1px solid #7b61ff;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123, 97, 255, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  // margin-top: 20px;
  margin: -24px;
  margin-bottom: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 25px;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #7b61ff;
                border-bottom: 1px solid #7b61ff;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #7b61ff;
                border-left: 1px solid #7b61ff;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(127, 133, 233, 0.1);
      border: 1px solid rgba(127, 133, 233, 1);
      color: #7f85e9;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url(../../assets/images/integralCenter/yhq.png);
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #7b61ff;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#7B61FF;
      background: rgba(123,97,255,0.1);
      border: 1px solid #7B61FF;
      &:hover{
        color: #fff;
        background: #7B61FF;
      }
    }
    .reset{
      color: #7b61ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  //   .el-step__line {
  //     background-color: #7B61FF;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #7B61FF;
  //   border-color: #7B61FF;
  // }
  // .el-step__title.is-process {
  //   color: #7B61FF;
  // }
  // .el-step__title.is-success {
  //   color: #7B61FF;
  // }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
